// Mock data for THAVAI TECHNOLOGIES website

export const services = [
  {
    id: 1,
    title: "AI & Machine Learning",
    description: "Leverage cutting-edge AI solutions to automate processes, predict outcomes, and drive intelligent decision-making.",
    icon: "brain"
  },
  {
    id: 2,
    title: "Cloud Computing",
    description: "Scalable, secure cloud infrastructure solutions for modern enterprises with AWS, Azure, and Google Cloud expertise.",
    icon: "cloud"
  },
  {
    id: 3,
    title: "Software Development",
    description: "Custom enterprise software solutions built with modern technologies and agile methodologies.",
    icon: "code"
  },
  {
    id: 4,
    title: "Web & Mobile Applications",
    description: "Beautiful, responsive web and mobile applications that deliver exceptional user experiences.",
    icon: "smartphone"
  },
  {
    id: 5,
    title: "Data Analytics",
    description: "Transform raw data into actionable insights with advanced analytics and business intelligence solutions.",
    icon: "bar-chart"
  },
  {
    id: 6,
    title: "Cybersecurity",
    description: "Comprehensive security solutions to protect your digital assets and ensure compliance.",
    icon: "shield"
  },
  {
    id: 7,
    title: "DevOps Solutions",
    description: "Streamline development and operations with continuous integration and deployment pipelines.",
    icon: "git-branch"
  },
  {
    id: 8,
    title: "IT Consulting",
    description: "Strategic technology consulting to align IT initiatives with business objectives.",
    icon: "lightbulb"
  }
];

export const solutions = [
  {
    id: 1,
    industry: "Healthcare",
    description: "Digital health platforms, telemedicine solutions, and patient data management systems.",
    icon: "heart-pulse"
  },
  {
    id: 2,
    industry: "Finance",
    description: "Secure fintech solutions, payment gateways, and financial management systems.",
    icon: "building-2"
  },
  {
    id: 3,
    industry: "Retail",
    description: "E-commerce platforms, inventory management, and customer experience solutions.",
    icon: "shopping-cart"
  },
  {
    id: 4,
    industry: "Manufacturing",
    description: "Smart factory solutions, IoT integration, and supply chain optimization.",
    icon: "factory"
  },
  {
    id: 5,
    industry: "Education",
    description: "E-learning platforms, student management systems, and educational technology.",
    icon: "graduation-cap"
  },
  {
    id: 6,
    industry: "Government",
    description: "Citizen services portals, data governance, and public sector digital transformation.",
    icon: "landmark"
  }
];

export const whyChooseUs = [
  {
    id: 1,
    title: "Expert Team",
    description: "Highly skilled professionals with deep industry expertise",
    icon: "users"
  },
  {
    id: 2,
    title: "Innovation Driven",
    description: "Cutting-edge solutions using latest technologies",
    icon: "rocket"
  },
  {
    id: 3,
    title: "Enterprise Security",
    description: "Bank-level security and compliance standards",
    icon: "lock"
  },
  {
    id: 4,
    title: "Scalable Solutions",
    description: "Architecture that grows with your business",
    icon: "trending-up"
  },
  {
    id: 5,
    title: "Global Delivery",
    description: "24/7 support across multiple time zones",
    icon: "globe"
  },
  {
    id: 6,
    title: "24/7 Support",
    description: "Round-the-clock technical assistance",
    icon: "headphones"
  }
];

export const statistics = [
  { id: 1, value: 100, label: "Projects", suffix: "+" },
  { id: 2, value: 50, label: "Clients", suffix: "+" },
  { id: 3, value: 15, label: "Industries", suffix: "+" },
  { id: 4, value: 98, label: "Client Satisfaction", suffix: "%" }
];

export const testimonials = [
  {
    id: 1,
    name: "Sarah Johnson",
    position: "CTO, TechCorp Global",
    content: "THAVAI Technologies transformed our digital infrastructure. Their expertise in cloud solutions helped us scale efficiently and reduce costs by 40%.",
    rating: 5
  },
  {
    id: 2,
    name: "Michael Chen",
    position: "CEO, FinanceHub",
    content: "Outstanding AI implementation! The machine learning models they developed have significantly improved our prediction accuracy and customer satisfaction.",
    rating: 5
  },
  {
    id: 3,
    name: "Emily Rodriguez",
    position: "Director of IT, HealthFirst",
    content: "Professional, reliable, and innovative. THAVAI's team delivered our telemedicine platform ahead of schedule with exceptional quality.",
    rating: 5
  }
];

export const careers = [
  {
    id: 1,
    title: "Senior Full Stack Developer",
    department: "Engineering",
    location: "Remote / Hybrid",
    type: "Full-time"
  },
  {
    id: 2,
    title: "AI/ML Engineer",
    department: "Data Science",
    location: "Remote / Hybrid",
    type: "Full-time"
  },
  {
    id: 3,
    title: "Cloud Architect",
    department: "Infrastructure",
    location: "Remote / Hybrid",
    type: "Full-time"
  },
  {
    id: 4,
    title: "DevOps Engineer",
    department: "Operations",
    location: "Remote / Hybrid",
    type: "Full-time"
  },
  {
    id: 5,
    title: "Software Development Intern",
    department: "Engineering",
    location: "Remote",
    type: "Internship"
  },
  {
    id: 6,
    title: "Data Analytics Intern",
    department: "Data Science",
    location: "Remote",
    type: "Internship"
  }
];

export const contactInfo = {
  email: "contact@thavai.tech",
  phone: "+1 (555) 123-4567",
  address: "Galaxy N Ave, Gaur City 1, Sector 4, Ghaziabad, Uttar Pradesh 201016, India",
  socialLinks: {
    linkedin: "https://linkedin.com/company/thavai-technologies",
    twitter: "https://twitter.com/thavaitech",
    facebook: "https://facebook.com/thavaitech",
    instagram: "https://instagram.com/thavaitech"
  }
};

export const companyInfo = {
  vision: "To be the global leader in intelligent technology solutions that transform businesses and create lasting value.",
  mission: "Empowering organizations worldwide with innovative software solutions, cutting-edge AI, and strategic technology consulting that drives digital transformation and sustainable growth.",
  values: [
    "Innovation Excellence",
    "Client Success",
    "Integrity & Trust",
    "Continuous Learning",
    "Collaborative Spirit"
  ]
};